/**
 * Folders in the project list. A project's folder is stored in the project itself (so it travels to
 * the cloud and into downloaded files); this list only remembers folders that are still empty.
 */
import { normalizeFolder } from './format';

const KEY = 'stitchcraft.folders';

export function loadFolderList(): string[] {
  try {
    const v = JSON.parse(localStorage.getItem(KEY) ?? '[]') as unknown;
    return Array.isArray(v) ? v.map(normalizeFolder).filter((f): f is string => !!f) : [];
  } catch {
    return [];
  }
}

export function saveFolderList(folders: string[]): void {
  try {
    localStorage.setItem(KEY, JSON.stringify([...new Set(folders)]));
  } catch {
    /* storage unavailable: empty folders last for this session */
  }
}

/** All folders: the remembered ones and those that hold projects, sorted by name. */
export function allFolders(remembered: string[], fromProjects: (string | null)[], locale: string): string[] {
  const set = new Set<string>(remembered);
  for (const f of fromProjects) if (f) set.add(f);
  return [...set].sort((a, b) => a.localeCompare(b, locale, { sensitivity: 'base', numeric: true }));
}
